<template>
  <div class="content" v-if="giftLive !== {}">
    <div class="publish-time" v-show="giftLive.timeLong">
<!--      <i class="el-icon-time"></i>-->
<!--      数据时间：{{ $moment(giftLive.timeLong).format('YYYY-MM-DD HH:mm') }}-->
      <div>{{ $moment(giftLive.timeLong).format('YYYY-MM-DD HH:mm') }}更新</div>
    </div>
    <div class="element">
      <div class="index-item" v-for="index in 4" :key="index">
        <img src="../../../assets/images/赏花指数.png" alt="">
        <div class="name">赏花指数</div>
        <div>适宜赏花</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { findWind } from '@/utils/tool.js'
export default {
  props: ['params'],
  data () {
    return {
      giftLive: {},
      name: ''
    }
  },
  watch: {
    activeCountyId: {
      handler () {
        setTimeout(() => {
          const item = this.objsList.find(item => item.id === this.activeCountyId)
          this.name = item.name
          this.getGiftLive()
        }, 1000)
      }
    },
    tqskDateResult: {
      handler () {
        setTimeout(() => {
          this.getGiftLive()
        }, 1000)
      },
      deep: true
    }
  },
  mounted () {
    setTimeout(() => {
      const item = this.objsList.find(item => item.id === this.activeCountyId)
      this.name = item.name
      this.getGiftLive()
    }, 2000)
  },
  computed: {
    ...mapState('home', ['objsList', 'activeCountyId', 'cartData', 'tqskDateResult'])
  },
  methods: {
    ...mapMutations('home', ['changeCartItem']),
    /**
     * 实况数据
     */
    async getGiftLive () {
      this.giftLive = this.tqskDateResult
      this.giftLive.winddName = findWind(this.giftLive.windd)
    }
  }
}
</script>

<style lang="less" scoped>
.content {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  padding: 7vh 1.04vw 0.5vw;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  border-radius: 0.63vw;
  pointer-events: none;
  background: url('../../../assets/images/天气实况背景.png') no-repeat;
  background-size: 100%;

  .tab-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.52vw;
    font-size: 0.83vw;
    color: #FFFFFF;

    .left {
      display: flex;

      img {
        width: 0.83vw;
        margin-right: 0.42vw;
      }
    }

    .temp {
      font-size: 2.4vw;
      line-height: 0px;
      font-weight: 600;
      color: #89C3F2;
      text-align: center;
    }

  }

  .element {
    display: flex;
    justify-content: space-between;
    flex: 1;

    .index-item {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      width: calc((100% - 1.88vw) / 4);
      padding: 0.68vw 0vw;
      font-size: 0.73vw;
      color: #FFF;
      border-radius: 0.26vw;
      border: 2px solid;
      border-image: linear-gradient(135deg, rgba(112, 176, 247, 1), rgba(78, 133, 211, 0), rgba(112, 178, 250, 1)) 2 2;

      img {
        width: 2.19vw;
      }

      .name {
        font-size: 0.83vw;
        font-weight: 600;
        color: #AED4FD;
      }
    }
  }

  .publish-time {
    display: flex;
    align-items: center;
    position: absolute;
    right: 2.08vw;
    top: .8vw;
    ;
    color: #FFF;
    font-size: 0.63vw;

    .el-icon-time {
      margin-right: 0.26vw;
    }
  }
}

// }
</style>
